import React from 'react';

const StarIcon = ({ size = 50, color = "black" }) => (
  <svg width={size} height={size} viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 0L15.4542 7.91349H23.7822L16.6818 12.8085L19.636 20.7219L12.5 15.827L5.36395 20.7219L8.31819 12.8085L1.21775 7.91349H9.54584L12.5 0Z" stroke={color} strokeWidth="2" />
  </svg>
);

export default StarIcon;
